/* eslint-disable import/extensions */
import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/scss";
import "./slider.scss";

// DOM element getters
const $getSlider = () => document.querySelector(".desktop-slider-fixed-height");
const $getSwiperWrapper = slider => slider.querySelector(".swiper-wrapper");
const $getSwiperSlides = slider => slider.querySelectorAll(".swiper-slide");

// Lock height for mobile/tablet only (CSS handles desktop)
const lockMobileTabletHeight = () => {
  const slider = $getSlider();
  const screenWidth = window.innerWidth;

  // Only lock height for viewports below 1000px (mobile/tablet)
  if (slider && screenWidth < 1000) {
    // Ensure element is rendered before getting height
    requestAnimationFrame(() => {
      const initialHeight = slider.offsetHeight;

      // Safeguard: only set height if it's a valid positive value
      if (initialHeight > 0) {
        // Use consistent style assignment method
        slider.style.height = `${initialHeight}px`;
      }
    });
  }
};

// Handle responsive behavior on window resize
const handleResize = () => {
  const slider = $getSlider();
  if (!slider) return;

  const screenWidth = window.innerWidth;

  if (screenWidth >= 1000) {
    // For desktop (1000px and above), remove all inline styles to let CSS handle layout
    slider.style.height = "";

    const swiperWrapper = $getSwiperWrapper(slider);
    if (swiperWrapper) {
      swiperWrapper.style.height = "";
    }

    const swiperSlides = $getSwiperSlides(slider);
    swiperSlides.forEach(slide => {
      slide.style.height = "";
    });
  } else if (!slider.style.height) {
    // For mobile/tablet (below 1000px), reapply height lock if needed
    requestAnimationFrame(() => {
      const initialHeight = slider.offsetHeight;

      // Only set height if it's valid
      if (initialHeight > 0) {
        slider.style.height = `${initialHeight}px`;
      }
    });
  }
};

export default () => {
  // Initialize mobile/tablet height locking
  lockMobileTabletHeight();

  // Listen for window resize
  window.addEventListener("resize", handleResize);

  // Initialize Swiper
  const swiper = new Swiper(".js-hero-carousel", {
    modules: [Autoplay, Navigation],
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".js-hero-carousel-next-button",
      prevEl: ".js-hero-carousel-prev-button"
    }
  });

  // Cleanup function for event listeners
  const cleanup = () => {
    window.removeEventListener("resize", handleResize);
  };

  // Store cleanup function on swiper instance for later use if needed
  swiper.cleanup = cleanup;

  return swiper;
};
